const translations = {
  ...window.rebuyTranslations,
};

decodeAndParseHTML = (escapedHTML) => {
  // Step 1: Decode the escaped HTML string using a temporary element
  const tempElement = document.createElement('textarea');
  tempElement.innerHTML = escapedHTML;
  const decodedHTML = tempElement.value;

  // Step 2: Parse the decoded HTML string
  const parser = new DOMParser();
  const parsedHTML = parser.parseFromString(decodedHTML, 'text/html').body.innerHTML;

  return parsedHTML;
};

updateSmartCartLanguage = () => {
  const smartCartTranslations = translations.smart_cart;
  const subscriptionTranslations = translations.cart_switch_to_subscription;
  const tierProgressBarTranslations = translations.tier_progress_bar;
  const components = Rebuy?.SmartCart?.settings?.components;
  const buyMoreSaveMore = Rebuy?.SmartCart?.settings?.buy_more_save_more;
  const emptyCart = Rebuy?.SmartCart?.settings?.empty_cart_markup;
  const switchToSubscription = Rebuy?.SmartCart?.settings?.switch_to_subscription;
  const storefrontHelper = new ShopifyStorefrontHelper();

  if (smartCartTranslations && components) {
    components.forEach((component) => {
      switch (component.type) {
        case 'checkout': {
          const checkoutTranslation = {
            checkout_label: smartCartTranslations.checkout_label,
            view_cart_label: smartCartTranslations.view_cart_label,
            checking_out_label: smartCartTranslations.checking_out_label,
            view_cart_working_label: smartCartTranslations.view_cart_working_label,
            continue_shopping_label: smartCartTranslations.continue_shopping_label,
            terms_and_conditions_label: smartCartTranslations.terms_and_conditions_label,
          };
          Object.assign(component.settings.language, checkoutTranslation);
          break;
        }
        case 'custom_code_block': {

          const rebuySmartCart = document.querySelector('#rebuy-cart');
          const currentComponent = rebuySmartCart?.querySelector(`[data-rebuy-component-id='${component.component_id}']`);

          // Translate specific parts of the custom code blocks

          // Continue shopping label
          if (currentComponent.querySelector('#smartcart-continue-shopping-link')) {
            currentComponent.querySelector('#smartcart-continue-shopping-link').textContent = smartCartTranslations.continue_shopping_label;
          }

          // Taxes and Shipping text
          if (currentComponent.querySelector('#smartcart-taxes-and-shipping-text')) {
            currentComponent.querySelector('#smartcart-taxes-and-shipping-text').innerHTML = smartCartTranslations.taxes_and_shipping_at_checkout;
          }

          break;
        }
        case 'cart_subtotal': {
          const cartSubtotalTranslation = {
            subtotal_plural_text: smartCartTranslations.subtotal_plural_text,
            subtotal_singular_text: smartCartTranslations.subtotal_singular_text,
          };
          Object.assign(component.settings, cartSubtotalTranslation);
          break;
        }
        case 'tiered_progress_bar': {
          const keys = [
            'free_shipping_reached',
            'free_shipping_remaining',
            'product_amount_reached_label_text',
            'product_amount_remaining_label_text',
            'discount_amount_remaining_label_text',
            'discount_amount_reached_label_text',
          ];

          const translationsMap = {};

          keys.forEach((key) => {
            translationsMap[key] = decodeAndParseHTML(tierProgressBarTranslations[key]);
          });

          const {
            free_shipping_reached: freeShippingReached,
            free_shipping_remaining: freeShippingRemaining,
            product_amount_reached_label_text: productAmountReachedLabelText,
            product_amount_remaining_label_text: productAmountRemainingLabelText,
            discount_amount_remaining_label_text: discountAmountRemainingLabelText,
            discount_amount_reached_label_text: discountAmountReachedLabelText,
          } = translationsMap;

          const progressBarTranslation = {
            free_shipping_reached: freeShippingReached,
            free_shipping_remaining: freeShippingRemaining,
            product_amount_reached_label_text: productAmountReachedLabelText,
            product_amount_remaining_label_text: productAmountRemainingLabelText,
            discount_amount_remaining_label_text: discountAmountRemainingLabelText,
            discount_amount_reached_label_text: discountAmountReachedLabelText,
          };
          if (component.settings.bars) {
            component.settings.bars.forEach((bar) => {
              Object.assign(bar.language, progressBarTranslation);
              bar.earnedProducts?.forEach((product) => {
                storefrontHelper.updateProductJSON(product);
              });
              bar.tiers.forEach((tier, index) => {
                if (tier.type !== 'shipping') {
                  Object.assign(tier, progressBarTranslation);
                }
                if (tier.type === 'product') {
                  storefrontHelper.updateProductJSON(tier.products[0]);
                }
                if (tier.type === 'shipping') {
                  document.querySelectorAll('.rebuy-cart__progress-step-label')[index]
                    ? (document.querySelectorAll('.rebuy-cart__progress-step-label')[
                        index
                      ].innerText = tierProgressBarTranslations.free_shipping)
                    : null;
                }
              });
            });
          }
          break;
        }
        case 'title_bar': {
          const titleBarTranslation = {
            title: smartCartTranslations.cart_title,
          };
          Object.assign(component.settings, titleBarTranslation);
          break;
        }
        case 'login': {
          const loginTranslation = {
            title: smartCartTranslations.login_title,
          };
          Object.assign(component.settings.language, loginTranslation);
          break;
        }
        case 'discount_code': {
          const discountCodeTranslation = {
            discount_code_label: smartCartTranslations.discount_code_label,
            discount_button_label: smartCartTranslations.discount_button_label,
            discount_invalid_message: smartCartTranslations.discount_invalid_message,
          };
          Object.assign(component.settings.language, discountCodeTranslation);
          break;
        }
        case 'notes': {
          const notesTranslation = {
            notes_label: smartCartTranslations.notes_label,
            notes_placeholder: smartCartTranslations.notes_placeholder,
            notes_remaining_characters: smartCartTranslations.notes_remaining_characters,
          };
          Object.assign(component.settings.language, notesTranslation);
          break;
        }
      }
    });
    // Handle 'buy_more_save_more' settings
    if (buyMoreSaveMore) {
      const bmsmTranslation = {
        bmsm_discount_message: smartCartTranslations.bmsm_discount_message,
        bmsm_discount_success: smartCartTranslations.bmsm_discount_success,
      };
      Object.assign(buyMoreSaveMore.language, bmsmTranslation);
    }
    // Handle 'empty cart' settings
    if (emptyCart) {
      const escapedHTML = smartCartTranslations.empty_cart_markup; // The escaped HTML string
      const emptyCartMarkUp = decodeAndParseHTML(escapedHTML);

      const emptyCartTranslation = {
        empty_cart_markup: emptyCartMarkUp,
      };
      Object.assign(Rebuy?.SmartCart?.settings, emptyCartTranslation);
    }
    if (switchToSubscription) {
      const subscriptionTranslation = {
        downgrading_label: subscriptionTranslations.downgrading_label,
        onetime_option_group_label: subscriptionTranslations.onetime_option_group_label,
        onetime_option_label: subscriptionTranslations.onetime_option_label,
        subscription_option_group_label: subscriptionTranslations.subscription_option_group_label,
        upgrade_to_subscription_label: subscriptionTranslations.upgrade_to_subscription_label,
        upgrade_to_subscription_without_discount_label: subscriptionTranslations.upgrade_to_subscription_without_discount_label,
        upgrading_label: subscriptionTranslations.upgrading_label,
      };
      Object.assign(switchToSubscription.language, subscriptionTranslation);
    }
  }
};

updateWidgetLanguage = (widget) => {
  const locale = Shopify?.locale;
  const widgetTranslation = translations[widget.id];
  const globalTranslation = translations.widget;

  // Widget translations override matching global translation keys
  const widgetTranslations = {
    ...globalTranslation,
    ...widgetTranslation,
  };

  if (locale && widgetTranslations) {
    Object.assign(widget.data.settings.language, widgetTranslations);
    widget.compileConfig();
  }
};

updateTierLanguage = () => {
  const giftTitle = document.querySelector('.rebuy-cart__progress-gifts-title');
  const variantPrompt = document.querySelectorAll(
    '.rebuy-cart__progress-gift-variant-select-prompt'
  );
  const firstOption = document.querySelectorAll(
    '.rebuy-cart__progress-gift-variant-select option[value=""]'
  );
  if (giftTitle) {
    giftTitle.textContent = translations.smart_cart.gift_title;
  }
  if (variantPrompt) {
    variantPrompt.forEach((prompt) => (prompt.textContent = translations.smart_cart.select_gift));
  }
  if (firstOption) {
    firstOption.forEach((prompt) => (prompt.textContent = translations.smart_cart.select_gift));
  }
};

updateAnnouncementBar = () => {
  const announcementTranslations = translations.announcement_bar.bars;
  const components = Rebuy?.SmartCart?.settings?.components;

  if (announcementTranslations && components) {
    const announcementBars = components.filter((c) => c.type === 'announcement_bar');
    announcementBars.forEach((bar) => {
      announcementTranslations.forEach((translation, i) => {
        if (bar.settings.messages[i]) {
          bar.settings.messages[i] = translation;
        }
      });
    });
  }
};

// Update Smart Cart with locale translations
document.addEventListener('rebuy:smartcart.ready', () => {
  updateSmartCartLanguage();
  updateAnnouncementBar();
});

// Update widgets with locale translations
document.addEventListener('rebuy.ready', (event) => {
  const widget = event.detail.widget;
  updateWidgetLanguage(widget);

  updateSmartCartLanguage();
});

// Update free gifts text
document.addEventListener('rebuy:cart.change', () => {
  setTimeout(() => {
    updateTierLanguage();
    updateSmartCartLanguage();
    updateAnnouncementBar();
  }, 0);
});

// update product JSON every time products are loaded or changed
document.addEventListener('rebuy.productsChange', (e) => {
  const widget = e.detail.widget;
  const storefrontHelper = new ShopifyStorefrontHelper();

  // loop over products in the widget and enrich product json
  widget.data.products.forEach((product) => storefrontHelper.updateProductJSON(product));
});
